import { USER_ACTION_TYPES } from '../actions/types';

const initialState = {
  user: null,
  loading: false,
  error: null,
  message: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case USER_ACTION_TYPES.FETCH_USER_REQUEST:
    case USER_ACTION_TYPES.UPDATE_USER_REQUEST:
    case USER_ACTION_TYPES.DELETE_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case USER_ACTION_TYPES.FETCH_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload.user,
        message: action.payload.message,
        error: null
      };

    case USER_ACTION_TYPES.UPDATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload.user,
        message: action.payload.message,
        error: null
      };

    case USER_ACTION_TYPES.DELETE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        user: null,
        message: action.payload.message,
        error: null
      };

    case USER_ACTION_TYPES.FETCH_USER_FAILURE:
    case USER_ACTION_TYPES.UPDATE_USER_FAILURE:
    case USER_ACTION_TYPES.DELETE_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        message: null
      };

    case USER_ACTION_TYPES.SET_USER_DATA:
      return {
        ...state,
        user: action.payload.user
      };

    case USER_ACTION_TYPES.CLEAR_USER_ERRORS:
      return {
        ...state,
        error: null,
        message: null
      };

    default:
      return state;
  }
};
  